(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("loopBreaker", [], factory);
	else if(typeof exports === 'object')
		exports["loopBreaker"] = factory();
	else
		root["loopBreaker"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition